// @ts-nocheck
import React from 'react';

import { Container, Row, Col } from 'crehana-ui/GridV2';
import Slider from 'crehana-ui/Slider';

import { MentorsSection as IMentorsSection } from '../../types';

import Card from './Card';

const MentorsSection: React.FC<IMentorsSection> = ({
  title,
  subtitle,
  mentors,
}) => {
  return (
    <section className="bg-base-dark py-40 md:py-64">
      <Container>
        <Row className="mb-32 md:mb-48">
          <Col>
            <div className="mx-auto" style={{ maxWidth: 720 }}>
              <h2 className="font-h2 text-white text-center mb-16">{title}</h2>
              <p className="font-body3 text-gray-main text-center">
                {subtitle}
              </p>
            </div>
          </Col>
        </Row>
        <Row className="justify-center">
          <Col sm={12} md={12}>
            <div>
              <Slider
                itemsPerPage={{ xs: 1, sm: 3, md: 3, lg: 4 }}
                desktopPaginationSelector=".pagination"
                desktopPaginationType="dots"
                dark
              >
                {mentors.map(mentor => (
                  <Card key={mentor.id} {...mentor} />
                ))}
              </Slider>
              <div className="pagination max-w-280 mx-auto sm:mt-24 md:mt-48" />
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default MentorsSection;
